import { useEffect } from 'react'
import { UseMutationOptions } from 'react-query'

import { Token } from 'api/domain/auth'
import { useApiMutation, useAuth, useAppApi } from 'api'
import { AuthApi } from 'api/APIs'

export function useAutologin({
  token,
  onSuccess,
  onError,
  ...options
}: { token: string | null | undefined } & UseMutationOptions<Token>) {
  const { login } = useAuth()
  const authApi = useAppApi(AuthApi)

  const { mutate, ...rest } = useApiMutation<Token>(
    () => {
      if (!token) throw new Error('Token is not provided')
      return authApi.loginWithToken(token)
    },
    {
      ...options,
      onSuccess: (pair, ...args) => {
        login(pair)
        onSuccess?.(pair, ...args)
      },
      onError: (...args) => onError?.(...args),
    },
  )

  useEffect(() => {
    mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    mutate,
    ...rest,
  }
}
